import { AbstractPmsApiService } from "./abstract.service";
import { GuestsListPhoneNumber } from "../models";

/**
 * @class GuestsListPhoneNumberPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<GuestsListPhoneNumber>}
 */
export class GuestsListPhoneNumberPmsApiService extends AbstractPmsApiService {

    static get $inject() {

        return super.$inject.concat(['Upload']);
    }

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/guests-list/:guestsListId/phone-number(/:id)';
    }

    constructor(http, config, eventsBroker, Upload) {

        super(http, config, eventsBroker);

        this.Upload = Upload;
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {GuestsListPhoneNumber}
     * @protected
     */
    newModel(attributes, ...params) {

        return new GuestsListPhoneNumber(attributes);
    }

    /**
     * @param {Object=} params
     * @param {GuestsList=} guestsList
     * @returns {Promise.<PaginationCollection<GuestsListPhoneNumber>>}
     */
    get(params = {}, guestsList = null) {

        const url = this.url({guestsListId: guestsList ? guestsList.id : 0});

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {GuestsListPhoneNumber} number
     * @param {GuestsList=} guestsList
     * @returns {Promise.<GuestsListPhoneNumber>}
     */
    create(number, guestsList) {

        const url = this.url({guestsListId: guestsList.id});

        return this.http
            .post(url, number.toObject(), {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {GuestsListPhoneNumber} number
     * @returns {Promise.<GuestsListPhoneNumber>}
     */
    update(number) {

        const url = this.url({
            guestsListId: number.guests_list_id,
            id:           number.id
        });

        number = number.toObject();

        if (number.hasOwnProperty('guest_id') && !number.guest_id) {

            delete number.guest_id;
        }

        return this.http
            .put(url, number, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {GuestsListPhoneNumber} number
     * @returns {Promise.<boolean>}
     */
    delete(number) {

        const url = this.url({
            guestsListId: number.guests_list_id,
            id:           number.id
        });

        return this.http
            .delete(url, {
                headers: this.authHeaders
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {File=} file
     * @param {GuestsList=} guestsList
     * @returns {Promise.<boolean>}
     */
    import(file, guestsList) {

        const url = this.url({guestsListId: guestsList.id}) + '/import';

        return this.Upload
            .upload({
                url: url,
                headers: this.authHeaders,
                data: ({file})
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {array} selectedGuests
     * @param {GuestsList=} guestsList
     * @returns {Promise.<GuestsListPhoneNumber[]>}
     */
    bulkAdd(selectedGuests, guestsList) {

        const url = this.url({guestsListId: guestsList.id}) + '/bulk-add';

        return this.http
            .post(url, {'ids': selectedGuests}, {
                headers: this.authHeaders
            })
            .then(this.getMassModeler())
            .catch(this.getErrorHandler());
    }

    notExists(lists, code, number) {

        const url = this.url({guestsListId: 0}) + '/not-exists';

        return this.http
            .post(url, {
                'selected_lists': lists,
                'phone_code':     code,
                'phone_number':   number
            }, {
                headers: this.authHeaders
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/guests-list-phone-number.service.js